import React, { useState } from 'react';
import { DataView } from 'primereact/dataview';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Chips } from 'primereact/chips';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputNumber } from 'primereact/inputnumber';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Divider } from 'primereact/divider';

interface DatatableItemProps {
  data: any[];
  setData: (data: any[]) => void;
  fields: { [key: string]: string };
  className?: string;
}

const DatatableItem: React.FC<DatatableItemProps> = ({ data, setData, fields, className }) => {
  const [editingId, setEditingId] = useState<any | null>(null);

  const monthNavigatorTemplate = (e: any) => {
    return <Dropdown value={e.value} options={e.options} onChange={(event) => e.onChange(event.originalEvent, event.value)} style={{ lineHeight: 1 }} />
  }

  const yearNavigatorTemplate = (e: any) => {
    return <Dropdown value={e.value} options={e.options} onChange={(event) => e.onChange(event.originalEvent, event.value)} className="ml-2" style={{ lineHeight: 1 }} />
  }

  const itemTemplate = (item: any) => {
    console.log('item', item);

    const isEditing = editingId === item.id;

    const handleChange = (field: string, value: any) => {
      const newData = data.map(d => (d.id === item.id ? { ...d, [field]: value } : d));
      setData(newData);
    };

    return (
      <>
        {Object.entries(fields).filter(f => f[0] !== 'id').map(([field, header]) => {
          const isArray = Array.isArray(item[field]);

          return (
            <div key={field} className="col-12 md-4" style={{ marginBottom: '0.5em' }}>
              <label style={{ fontWeight: 'bold', display: 'block' }}>{header}:</label>
              {isEditing ? (
                (() => {
                  switch (field) {
                    case 'skills':
                      return <Chips value={item.skills} className="inputfield w-full" onChange={(e) => handleChange(field, e.value)} />;
                    case 'roleSummary':
                      return <InputTextarea value={item.roleSummary} className="inputfield w-full" onChange={(e) => handleChange(field, e.target.value)} rows={3} cols={20} />;
                    case 'numberOfYears':
                      return <InputNumber value={item.numberOfYears} className="inputfield w-full" onChange={(e) => handleChange(field, e.value)} onValueChange={(e) => handleChange(field, e.value)} />;
                    case 'dateIssued':
                      return <Calendar value={item.dateIssued}
                        yearRange={"1950:" + new Date().getFullYear()}
                        yearNavigator monthNavigator readOnlyInput showButtonBar
                        monthNavigatorTemplate={monthNavigatorTemplate}
                        yearNavigatorTemplate={yearNavigatorTemplate}
                        dateFormat="yy-mm-dd"
                        className="column-filter inputfield w-full"
                        placeholder="YYYY-MM-DD"
                        onChange={(e) => handleChange(field, e.target.value)} />;
                    default:
                      return <InputText value={item[field]} className="inputfield w-full" onChange={(e) => handleChange(field, e.target.value)} />;
                  }
                })()
              ) : (
                <div>
                  {isArray ? (
                    <div className="flex flex-wrap gap-2">
                      {item[field].map((value: any, index: number) => (
                        <div key={index} className="p-chip">
                          {String(value)}
                        </div>
                      ))}
                    </div>
                  ) : (
                    String(item[field])
                  )}
                </div>
              )}
            </div>
          );
        })}
        <div className="col-12 py-2 border-bottom-1 surface-border">
          {isEditing ? (
            <>
              <Button label="Save" icon="pi pi-check" className="p-button-success mr-2" onClick={() => setEditingId(null)} />
              <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={() => setEditingId(null)} />
            </>
          ) : (
            <Button label="Edit" icon="pi pi-pencil" onClick={() => setEditingId(item.id)} />
          )}
          <Button label="Delete" icon="pi pi-trash" className="p-button-danger ml-2" onClick={() => removeItem(item.id)} />
        </div>
      </>
    );
  };

  const addItem = () => {
    const newItem: any = { id: Date.now() }; // Generate a unique ID
    Object.keys(fields).forEach(field => {
      newItem[field] = '';
    });
    setData([...data, newItem]);
  };

  const removeItem = (id: any) => {
    const newData = data.filter(item => item.id !== id);
    setData(newData);
  };

  return (
    <div className={className}>
      <div className="card">
        {data.length > 0 && <DataView value={data} layout="list" itemTemplate={itemTemplate} /> }
        <Button label="Add" icon="pi pi-plus" className="mt-2" onClick={addItem} />
      </div>
    </div>
  );
};

export default DatatableItem;